module.exports = __webpack_public_path__ + "img/2.8520b3f0.jpg";